module.exports = __webpack_public_path__ + "stylesheets/tabs_87a43c3823c1cefa549b76dacf440d1f.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/tabs.less
// module id = 4eYb
// module chunks = 51